module.exports = __webpack_public_path__ + "img/YoureFree.5634e660.jpeg";